/**
 * Tab filtering for the blog articles hub section.
 */
class BlogArticlesHub extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-blog-filter]');
    this.cards = this.querySelectorAll('[data-blog-handle]:not([data-empty-message])');
    this.emptyMessages = this.querySelectorAll('[data-empty-message]');
    this.countEl = this.querySelector('[data-article-count]');

    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#setFilter(tab.dataset.blogFilter));
    });

    this.#setFilter('all');
  }

  #setFilter(handle) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.blogFilter === handle;
      tab.classList.toggle('blog-articles-hub__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    let visible = 0;

    this.cards.forEach((card) => {
      const show = handle === 'all' || card.dataset.blogHandle === handle;
      card.hidden = !show;
      if (show) visible += 1;
    });

    // Show the "no blogs found" message only when its own tab is selected
    // and that blog has no visible articles.
    this.emptyMessages.forEach((message) => {
      message.hidden = !(handle === message.dataset.blogHandle && visible === 0);
    });

    if (this.countEl) {
      this.countEl.textContent = String(visible);
    }
  }
}

if (!customElements.get('blog-articles-hub')) {
  customElements.define('blog-articles-hub', BlogArticlesHub);
}
